import { createBrowserRouter } from "react-router-dom";
import { routes } from "./routes.tsx";

export const router = createBrowserRouter(routes);
